export const it = {
  subtitle: 'Indovina il Paese del giorno',
  modes: { classic: 'Classica', flag: 'Bandiere', outline: 'Sagome', connections: 'Connessioni', trivia: 'Quiz', draw: 'Disegno' },
  recommendations: {
    title: 'Potrebbero piacerti anche',
    open: 'Apri {name}',
    games: {
      wormillion: 'Gioco quotidiano di geografia con risposte rare',
      stardewdle: 'Rompicapi quotidiani nel mondo di Stardew Valley',
      cascadle: 'Gioco di parole quotidiano a cascata',
      farhike: 'Sfida quotidiana sulla mappa con Paesi poco citati',
    },
  },
  draw: {
    subtitle: 'Traccia il profilo a memoria',
    askLabel: 'Disegna questo Paese',
    drawingLabel: 'Disegno',
    askHint: 'A memoria: nessun riferimento, un solo tentativo.',
    blank: 'foglio bianco, niente ricalco',
    canvasLabel: 'Tela da disegno',
    start: 'Inizia a disegnare',
    undo: 'Annulla',
    clear: 'Cancella',
    done: 'Fatto',
    next: 'Paese successivo',
    score: 'Punteggio',
    accuracy: 'Precisione',
    coverage: 'Copertura',
    deviation: 'Scarto',
    legendTrue: 'Profilo reale',
    legendYours: 'Il tuo tratto',
    legendOut: 'Troppo in fuori',
    legendIn: 'Troppo in dentro',
    pts: 'pt',
    learnMore: 'Scopri di più',
    ranks: [
      'Cartografo di Corte',
      'Maestro Cartografo',
      'Abile Agrimensore',
      'Mano Ferma',
      'Apprendista',
      'Schizzo Grezzo',
      'Torna sull’Atlante',
    ],
  },
  trivia: {
    subtitle: 'Dieci domande di geografia al giorno',
    loading: 'Caricamento delle domande di oggi…',
    question: 'Domanda',
    correct: 'Esatto!',
    wrong: 'Non ci siamo',
    next: 'Domanda successiva',
    seeResult: 'Vedi il risultato',
    xpNote: '3 XP per ogni risposta corretta, +10 per un dieci pieno.',
    comeBack: 'Dieci domande nuove a mezzanotte UTC.',
    tiers: ['Impeccabile: dieci su dieci!', 'Ottimo colpo d’occhio.', 'Niente male. Riprova domani.', 'Giornata storta. Il mondo è grande.'],
  },
  conn: {
    subtitle: 'Dividi 16 Paesi in 4 gruppi',
    oneAway: 'Manca poco…',
    shuffle: 'Mescola',
    deselect: 'Deseleziona',
    submit: 'Invia',
    mistakes: 'Errori',
    solved: 'Risolto!',
    lost: 'Sarà per la prossima!',
    nextPuzzle: 'Rompicapo successivo',
    flawless: 'Impeccabile: nessun errore!',
    wellPlayed: 'Bel colpo.',
    lostSub: 'I quattro gruppi sono svelati qui sopra.',
    guesses: 'Tentativi',
  },
  soon: 'presto',
  streak: 'Serie',
  today: 'Oggi',
  yesterday: 'Ieri',
  nextIn: 'Prossimo Paese tra',
  daily: 'Giornaliera',
  unlimited: 'Illimitata',
  nextCountry: 'Paese successivo',
  skip: 'Salta',
  solved: 'Risolti',
  best: 'Record',
  emptyHint: 'Fai il primo tentativo per svelare gli indizi.',
  boardScrollLabel: 'Tabella comparativa dei tentativi. Scorri orizzontalmente per vedere tutti gli indizi.',
  legend: { correct: 'Corrisponde', incorrect: 'Non corrisponde', numbers: 'risposta ↑ più alta · ↓ più bassa', distance: 'vicino → lontano' },
  placeholder: 'Scrivi un Paese…',
  guess: 'Prova',
  won: 'Risolto!',
  lost: 'Tentativi esauriti',
  answerWas: 'Il Paese era',
  answerCard: { viewProfile: 'Vedi profilo', northernHemisphere: 'Emisfero boreale', southernHemisphere: 'Emisfero australe' },
  share: 'Condividi',
  copyLink: 'Copia il link',
  copyResult: 'Copia il risultato',
  copyEmbed: 'Copia il codice',
  saveImage: 'Salva l’immagine',
  shareToday: 'Condividi oggi',
  copied: 'Copiato!',
  cols: { region: 'Regione', pop: 'Pop.', area: 'Superf.', borders: 'Confini', gdp: 'PIL', temp: 'Temp.', dist: 'Distanza' },
  colTips: {
    region: 'Il continente in cui si trova il Paese. Il verde indica lo stesso continente della risposta.',
    dist: 'Distanza in linea d’aria fra il tuo tentativo e la risposta. Il rosso è lontano, il verde è vicino; la freccia punta verso la risposta.',
    borders: 'Con quanti Paesi condivide un confine terrestre. ↑ significa che la risposta ne ha di più.',
    temp: 'Temperatura media annua 1991-2020, calcolata su tutto il territorio e non sulla capitale.',
    pop: 'Popolazione totale. ↑ significa che la risposta ha più abitanti.',
    area: 'Superficie in km². ↑ significa che la risposta è più estesa.',
    gdp: 'PIL pro capite in dollari USA. ↑ significa che la risposta è più ricca per abitante.',
  },
  puzzle: {
    flag: 'Di quale Paese è questa bandiera?',
    outline: 'Di quale Paese è questa forma?',
  },
  account: {
    signIn: 'Accedi',
    withGoogle: 'Continua con Google',
    withDiscord: 'Continua con Discord',
    tagline: 'Conserva la tua serie su tutti i dispositivi',
    signOut: 'Esci',
    level: 'Liv',
    viewProfile: 'Vedi il profilo',
    editProfile: 'Modifica profilo',
  },
  settings: {
    title: 'Modifica profilo',
    avatar: 'Immagine',
    change: 'Cambia',
    displayName: 'Nome visualizzato',
    bio: 'Descrizione',
    bioPh: 'Racconta qualcosa di te agli altri esploratori…',
    birthday: 'Data di nascita',
    country: 'Paese',
    countryNone: 'Non indicato',
    gender: 'Genere',
    genders: { male: 'Uomo', female: 'Donna', other: 'Altro', na: 'Preferisco non dirlo' },
    socials: 'Profili social',
    invalidUrl: 'Inserisci un indirizzo valido per quella piattaforma.',
    date: { year: 'Anno', month: 'Mese', day: 'Giorno' },
    save: 'Salva',
    saving: 'Salvataggio…',
    saved: 'Salvato',
    signInRequired: 'Accedi per modificare il profilo.',
    cropTitle: 'Ritaglia l’immagine',
    cropHint: 'Trascina per spostare · scorri per ingrandire',
    apply: 'Applica',
    cancel: 'Annulla',
    pick: 'Scegli un’immagine',
    uploadError: 'Caricamento non riuscito: prova con un’immagine più piccola.',
  },
  netError: 'Problema di rete: riprova.',
  offlinePractice: 'Allenamento offline: non conta in classifica.',
  xp: 'XP',
  levelUp: 'Livello superato!',
  honors: {
    title: 'Distintivi e medaglie',
    intro: 'Ogni rompicapo che completi viene registrato in tre modi: un grado che ti porti dietro, una medaglia che vinci e un distintivo che devi difendere.',
    levelT: 'Distintivi di livello',
    levelD: 'Gli XP del gioco quotidiano ti accompagnano attraverso 14 vascelli incisi, dal bastone del viandante all’ammiraglia che solca il mondo.',
    dailyT: 'Medaglie giornaliere',
    dailyD: 'La classifica di Oggi ordina gli esploratori in base a quante delle sei modalità hanno risolto e poi a quanti tentativi hanno impiegato. I primi tre si prendono oro, argento e bronzo, conteggiati per sempre sul profilo.',
    boardT: 'Distintivi di classifica',
    boardD: 'Resta nei primi tre nelle classifiche Serie, Illimitata o Livello e ogni giorno viene inciso sul distintivo. I giorni d’oro, d’argento e di bronzo si contano separatamente.',
    cta: 'Vai alla classifica',
  },
  lb: {
    scoreBreakdown: 'Dettaglio del punteggio',
    scoreAvg: 'Media',
    scoreNote: 'Si ordina prima per modalità completate e poi per questa media.',
    title: 'Classifica',
    today: 'Oggi',
    streak: 'Serie',
    level: 'Livello',
    unlimited: 'Illimitata',
    connections: 'Connessioni',
    myRank: 'La tua posizione',
    empty: 'Ancora nessuno: sii il primo.',
    signInToRank: 'Accedi per comparire in classifica.',
    guesses: 'tentativi',
    guess1: 'tentativo',
    totalSolved: 'Risolti',
    yourStats: 'Le tue statistiche',
    back: 'Torna al gioco',
    nav: 'Classifica',
    viewAll: 'Vedi tutti',
    dailyMedals: 'Medaglie giornaliere',
    heldBadges: 'Distintivi di classifica',
    notFound: 'Esploratore non trovato.',
  },
  privacy: {
    title: 'Informativa sulla privacy',
    updated: 'Ultimo aggiornamento: 28 giugno 2026',
    sections: [
      {
        h: 'Chi siamo',
        p: ['GeoDle («noi») è un gioco di geografia quotidiano e gratuito disponibile su geodle.org.'],
      },
      {
        h: 'Quali dati raccogliamo',
        p: [
          'Dati di gioco: i tuoi tentativi, l’avanzamento quotidiano, la serie e i punti esperienza, conservati per far funzionare il gioco e sincronizzarlo fra i tuoi dispositivi.',
          'Dati dell’account (solo se accedi con Google o Discord): un identificativo univoco, il nome visualizzato e l’immagine del profilo. Non riceviamo mai la tua password.',
        ],
      },
      {
        h: 'Come usiamo i tuoi dati',
        p: [
          'Per salvare e sincronizzare i progressi, calcolare serie e livelli e mostrare classifiche e profili pubblici dei giocatori registrati.',
          'Non vendiamo i tuoi dati e non li usiamo a fini pubblicitari.',
        ],
      },
      {
        h: 'Statistiche e cookie',
        p: [
          'Usiamo Google Analytics e Microsoft Clarity per capire in forma anonima e aggregata come viene usato il sito. Questi servizi possono impostare cookie propri; non li usiamo per identificarti personalmente.',
          'Usiamo un cookie di prima parte per mantenerti connesso e sincronizzare i tuoi progressi.',
        ],
      },
      {
        h: 'I tuoi diritti e la cancellazione',
        p: [
          'Puoi cancellare in modo definitivo il tuo account e tutti i dati collegati in qualsiasi momento con il pulsante qui sotto. La cancellazione ha effetto immediato.',
        ],
      },
      { h: 'Contatti', p: ['Domande sui tuoi dati? Scrivi a contact@geodle.org.'] },
    ],
    deleteAccount: 'Cancella account e dati',
    deleteConfirm: 'Questa operazione cancella per sempre il tuo account e tutti i progressi. Vuoi continuare?',
    deleted: 'Il tuo account e i tuoi dati sono stati cancellati.',
  },
  terms: {
    title: 'Termini di servizio',
    updated: 'Ultimo aggiornamento: 28 giugno 2026',
    sections: [
      {
        h: 'Accettazione',
        p: ['Usando GeoDle accetti questi termini. Se non li accetti, ti preghiamo di non usare il servizio.'],
      },
      {
        h: 'Il servizio',
        p: [
          'GeoDle è un gioco di geografia quotidiano e gratuito fornito «così com’è» per intrattenimento personale e non commerciale. Possiamo modificarne, sospenderne o interromperne qualsiasi parte in qualsiasi momento.',
        ],
      },
      {
        h: 'Account e correttezza di gioco',
        p: [
          'L’accesso è facoltativo e serve a sincronizzare i progressi e a inserirti nelle classifiche. Sei responsabile dell’attività svolta con il tuo account.',
          'Non barare, non automatizzare il gioco e non manipolare in altro modo punteggi, serie o classifiche. Possiamo rimuovere i risultati o gli account che lo fanno.',
        ],
      },
      {
        h: 'Uso consentito',
        p: [
          'Scegli un nome visualizzato e un’immagine che non siano offensivi, lesivi di diritti altrui o ingannevoli. Possiamo rimuovere i contenuti o gli account che violano questa regola.',
        ],
      },
      {
        h: 'Proprietà intellettuale',
        p: [
          'I dati sui Paesi provengono da archivi aperti (mledoze/countries, Natural Earth). GeoDle è un progetto indipendente e non è collegato ad alcun governo od organizzazione.',
        ],
      },
      {
        h: 'Esclusioni e responsabilità',
        p: [
          'Il servizio è fornito senza garanzie di alcun tipo. Nei limiti consentiti dalla legge, non rispondiamo di alcun danno derivante dall’uso di GeoDle.',
        ],
      },
      {
        h: 'Modifiche',
        p: ['Possiamo aggiornare questi termini di tanto in tanto. Continuare a usare il servizio dopo una modifica significa accettare i termini aggiornati.'],
      },
      { h: 'Contatti', p: ['Domande? Scrivi a contact@geodle.org.'] },
    ],
  },
  country: {
    whereOnEarth: 'Dove si trova',
    atAGlance: 'In breve',
    howItCompares: 'Come si confronta',
    neighbours: 'Paesi confinanti',
    inGeoDle: '{name} su GeoDle',
    exploreNearby: 'Esplora qui vicino',
    faqTitle: 'Domande frequenti',
    metaTitle: '{name} — Capitale, popolazione, superficie e dati | GeoDle',
    metaDesc: '{name}: capitale {capital}, popolazione {pop}, superficie {area} km². È il {rankPop} Paese più popoloso, in {region}. Dati, mappa, Paesi confinanti e altro ancora.',
    getToKnow: '{name}: cosa sapere',
    k: { history: 'Momenti storici', people: 'Personaggi celebri', landmarks: 'Luoghi da vedere', culture: 'Cultura e sapori' },
    sources: 'Fonti',
    listTitle: 'Paesi',
    listSearch: 'Cerca un Paese…',
    listAll: 'Tutte le regioni',
    listCount: '{n} Paesi',
    listEmpty: 'Nessun Paese corrisponde alla ricerca.',
    promoTitle: 'Esplora tutti i Paesi',
    promoDesc: 'Bandiere, capitali, popolazione e un mappamondo interattivo: una scheda di approfondimento per tutti i 194 Paesi.',
    promoCta: 'Sfoglia i Paesi',
    metaTitleList: 'Tutti i Paesi del mondo — bandiere, capitali e dati | GeoDle',
    metaDescList: 'Sfoglia tutti i Paesi: bandiere, capitali, popolazione, superficie e altro. Cerca e filtra per regione ed esplora il mondo su un mappamondo interattivo.',
    play: 'Gioca',
    guessFlag: 'Indovina la bandiera',
    guessOutline: 'Indovina la sagoma',
    back: 'GeoDle',
    notFound: 'Paese non trovato.',
    landlocked: 'Senza sbocco sul mare',
    coastal: 'Con sbocco sul mare',
    north: 'Nord',
    south: 'Sud',
    landBorders: '{n} confini terrestri',
    landBorder: '1 confine terrestre',
    noBorders: '{name} non ha confini terrestri.',
    locLede: '{name} si trova in {subregion}, {region}.',
    locLandlocked: 'Non ha sbocco sul mare.',
    locCoastal: 'Si affaccia sul mare.',
    locBorders: 'Confina via terra con {n} Paesi.',
    locBorder: 'Confina via terra con un solo Paese.',
    locIsland: 'Essendo un Paese insulare non ha confini terrestri.',
    f: { capital: 'Capitale', population: 'Popolazione', area: 'Superficie', region: 'Regione', subregion: 'Sottoregione', coast: 'Costa', hemisphere: 'Emisfero', iso: 'ISO', languages: 'Lingue', currency: 'Valuta', timezone: 'Fuso orario', calling: 'Prefisso', driving: 'Guida', tld: 'Dominio', nativeName: 'Nome locale' },
    s: {
      popWorld: 'Paese più popoloso del mondo (su {total}).',
      popRegion: 'più popoloso in {region} (su {total}).',
      areaLargest: 'per superficie',
      biggerThan: 'più esteso ({x})',
      smallerThan: 'meno esteso ({x})',
      perKm2: 'abitanti per km²',
      sparse: 'popolazione rada',
      moderate: 'densità media',
      dense: 'popolazione densa',
      morePeople: 'più abitanti ({x})',
      fewerPeople: 'meno abitanti ({x})',
      vs: 'vs',
      neighbours: 'Paesi confinanti',
      neighbour: 'Paese confinante',
    },
    q: {
      capitalQ: '{name}: qual è la capitale?',
      capitalA: 'La capitale di {name} è {capital}.',
      popQ: '{name}: quanti abitanti ha?',
      popA: '{name} ha circa {pop} abitanti: è il {rank} Paese più popoloso del mondo.',
      areaQ: '{name}: quanto è grande?',
      areaA: '{name} ha una superficie di {area} km², il che ne fa il {rank} Paese più esteso.',
      regionQ: '{name}: in quale regione si trova?',
      regionA: '{name} si trova in {subregion}, {region}.',
    },
  },
  footer:
    'Dati sui Paesi: mledoze/countries (ODbL) · Dati cartografici: Natural Earth (dominio pubblico). GeoDle è un progetto indipendente, non collegato ad alcun governo od organizzazione.',
};
